import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-cookie-management-policy',
    imports: [TranslateModule],
    templateUrl: './cookie-management-policy.component.html',
    styleUrl: './cookie-management-policy.component.scss'
})
export class CookieManagementPolicyComponent {

    constructor(){

    }
}